// 引入组件
import Vue from 'vue'
import VueRouter from 'vue-router'
import {
	Message
} from 'element-ui';
import Home from './views/home/home.vue'
import Error from './views/home/error.vue'
import Login from './views/home/login.vue'
import GoodsList from './views/goods/goodslist.vue'
import GoodsDetail from './views/goods/goodsdetail.vue'
import AddressList from './views/mine/addresslist.vue'
import TradeConfirm from './views/trade/tradeconfirm.vue'
import TradeList from './views/trade/tradelist.vue'
import TradeListOmni from './views/trade/tradelistomni.vue'
import TradeDetail from './views/trade/tradedetail.vue'
import TradeDetailOmni from './views/trade/tradedetailomni.vue'
import TradeDetailJmc from './views/trade/tradedetailjmc.vue'
import ShopCart from './views/mine/shopcart.vue'
import Pay from './views/pay/pay.vue'
import PaySuccess from './views/pay/success.vue'
import ContactService from './views/mine/contactservice.vue'
import CollectList from './views/mine/collectlist.vue'
import TimedSaleGoodsDetails from './views/goods/timedsalegoodsdetail.vue'
import TimedSaleGoodsList from './views/goods/timedsalegoodslist.vue'
import DesignPage from './views/home/designpage.vue'
import QuickShopping from './views/goods/quickshopping.vue'

// 使用组件
Vue.use(VueRouter)

// 向外抛出一个VueRouter
const router = new VueRouter({
	// mode: 'history',
	// base: '/jmc_450001/',
	routes: [
		// 默认选中首页组件
		{
			path: '/',
			redirect: '/home'
		},
		{
			path: '/home',
			name: 'home',
			meta: {
				//自定义数据对象
				keepAlive: true, //缓存此页面
				refreshPage: true //是否刷新此页面
			},
			component: Home,
		},
		{
			path: '/login',
			name: 'login',
			component: Login
		},
		{
			path: '/error',
			name: 'error',
			component: Error
		},
		{
			path: '/goodslist',
			name: 'goodslist',
			meta: {
				//自定义数据对象
				keepAlive: true, //缓存此页面
				refreshPage: true //是否刷新此页面
			},
			component: GoodsList
		},
		{
			path: '/goodsdetail',
			name: 'goodsdetail',
			meta: {
				//自定义数据对象
				// keepAlive: true, //缓存此页面
				refreshPage: true //是否刷新此页面
			},
			component: GoodsDetail
		},
		{
			path: '/addresslist',
			name: 'addresslist',
			component: AddressList
		},
		{
			path: '/tradeconfirm',
			name: 'tradeconfirm',
			component: TradeConfirm,
			meta: {
				//自定义数据对象
				refreshPage: true, //是否刷新此页面
			},
		},
		{
			path: '/tradelist',
			name: 'tradelist',
			meta: {
				//自定义数据对象
				keepAlive: true, //缓存此页面
				refreshPage: true, //是否刷新此页面
				refreshTab: 0, //跳转的tab页
			},
			component: TradeList
		},
		{
			path: '/tradelistomni',
			name: 'tradelistomni',
			meta: {
				//自定义数据对象
				keepAlive: true, //缓存此页面
				refreshPage: true, //是否刷新此页面
				refreshTab: 0, //跳转的tab页
			},
			component: TradeListOmni
		},
		{
			path: '/tradedetail',
			name: 'tradedetail',
			component: TradeDetail,
			meta: {
				isEdit: false //是否做过数据修改
			},
		},
		{
			path: '/tradedetailomni',
			name: 'tradedetailomni',
			component: TradeDetailOmni,
			meta: {
				isEdit: false //是否做过数据修改
			},
		},
		{
			path: '/tradedetailjmc',
			name: 'tradedetailjmc',
			component: TradeDetailJmc
		},
		{
			path: '/shopcart',
			name: 'shopcart',
			component: ShopCart
		},
		{
			path: '/pay',
			name: 'pay',
			component: Pay
		},
		{
			path: '/success',
			name: 'paysuccess',
			component: PaySuccess
		},
		{
			path: '/contactservice',
			name: 'contactservice',
			component: ContactService
		},
		{
			path: '/collectlist',
			name: 'collectlist',
			component: CollectList
		},
		{
			path: '/timedsalegoodsdetail',
			name: 'timedsalegoodsdetail',
			component: TimedSaleGoodsDetails
		},
		{
			path: '/timedsalegoodslist',
			name: 'timedsalegoodslist',
			component: TimedSaleGoodsList
		},
		{
			path: '/designpage',
			name: 'designpage',
			component: DesignPage
		},
		{
			path: '/quickshopping',
			name: 'quickshopping',
			meta: {
				keepAlive: true, // 缓存此页面
				refreshPage: true // 是否刷新此页面
			},
			component: QuickShopping
		},
	]
})

// 解决不能跳转到当前页面的报错信息
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

// 页面跳转监听
router.beforeEach((to, from, next) => {
	// 检测订购状态，做出提示（不拦截，下单会有拦截）
	let productOrderErrMsg = localStorage.getItem("productOrderErrMsg");
	if (productOrderErrMsg) {
		Message({
			// message: '商城升级中，请联系商家处理',
			message: productOrderErrMsg,
			type: 'error', // 可以是 'success', 'warning', 'info', 'error'
			duration: 3000 // 显示时间，毫秒。默认值是 3000 毫秒
		});
	}

	next();
})

export default router;